import { createApp } from 'vue'
import App from './App.vue'
import router from './router'; // 引入路由配置
import ElementPlus, { ElMessage } from 'element-plus'//引入elementPlus
import 'element-plus/dist/index.css'//引入elementPlus
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import "@/styles/ElementScss.scss"
import $ from 'jquery';
import 'jquery-confirm';

// 将 jQuery 挂载到全局（如果需要）
window.$ = $;
window.jQuery = $;

const app = createApp(App);
//导入Element图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
//element-plus 报错 ResizeObserver loop limit exceeded 解决
const debounce = (fn, delay) => {
  let timer = null;
  return function () {
    let context = this;
    let args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  }
}
const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver{
  constructor(callback) {
    callback = debounce(callback, 16);
    super(callback);
  }
}

app.use(router); // 注册路由
app.use(ElementPlus, {
  locale: zhCn
})
// 全局错误处理
app.config.errorHandler = (err) => {
  console.error('全局捕获错误:', err)
  // ElMessage.error(err.message || '发生未知错误')
}

// 未处理的Promise rejection
window.addEventListener('unhandledrejection', (event) => {
  console.error('未处理的Promise错误:', event.reason)
  // ElMessage.error(event.reason?.message || '请求失败，请重试')
  event.preventDefault()
})

app.mount('#app');
